import { useContext } from 'react';

import { FocusFallbackContext } from '../context';
import type { FocusFallbacks } from '../types';

export function useFocusFallbackContext(): { fallbacks: FocusFallbacks } | undefined {
	return useContext(FocusFallbackContext);
}
